import axios from "axios";
import { getToken } from "../../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + "/admin/quick-boost",
  headers: {
    "Content-Type": "application/json",
  },
});

api.interceptors.request.use((config) => {
  const token = getToken();
  console.log("[QuickBoost] Bearer token present:", !!token);
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn("[QuickBoost] No token found, request may fail with 401");
  }
  return config;
});

export const fetchAllQuickBoosts = async (params) => {
  try {
    console.log("[QuickBoost] Fetching all quick boosts, params:", params);
    const res = await api.get("", { params });
    console.log("[QuickBoost] Fetch all response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[QuickBoost] Fetch all failed:", err.response?.status, err.response?.data);
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Failed to fetch",
    };
  }
};

export const fetchQuickBoostById = async (id) => {
  try {
    console.log("[QuickBoost] Fetching by id:", id);
    const res = await api.get(`/${id}`);
    console.log("[QuickBoost] Fetch by id response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[QuickBoost] Fetch by id failed:", id, err.response?.status, err.response?.data);
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Failed to fetch",
    };
  }
};

export const createQuickBoost = async (data) => {
  try {
    console.log("[QuickBoost] Creating:", data);
    const res = await api.post("", data);
    console.log("[QuickBoost] Create response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[QuickBoost] Create failed:", err.response?.status, err.response?.data);
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Create failed",
    };
  }
};

export const updateQuickBoost = async (id, data) => {
  try {
    console.log("[QuickBoost] Updating id:", id, "data:", data);
    const res = await api.put(`/${id}`, data);
    console.log("[QuickBoost] Update response:", res.status, res.data);
    return { status: res.status, data: res.data };
  } catch (err) {
    console.error("[QuickBoost] Update failed:", id, err.response?.status, err.response?.data);
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Update failed",
    };
  }
};

export const deleteQuickBoost = async (id) => {
  try {
    console.log("[QuickBoost] Deleting id:", id);
    const res = await api.delete(`/${id}`);
    console.log("[QuickBoost] Delete response:", res.status);
    return { status: res.status };
  } catch (err) {
    console.error("[QuickBoost] Delete failed:", id, err.response?.status, err.response?.data);
    return {
      status: err.response?.status || 500,
      message: err.response?.data?.message || "Delete failed",
    };
  }
};
